<template>
	<div class="treatment-plan">

		<InputGroup
			title="Add Notes"
			desc="Please add any notes in addition to the treatment plan."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<InputTextarea
				label="Notes"
				v-model="caseForm.treatment_plan_notes"
				:darkMode="true"
				/>

		</InputGroup>
		
		<InputGroup
			title="Upload Treatment Plan"
			desc="Please upload any files relevant to the treatment plan."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			
			<UploadBox 
				theme="dark"
				designation="treatment-plan"
				:maxFiles="1"
				:case="thisCase"
				@done="uploadDone"
				@filesAdded="filesAdded"
				/>

		</InputGroup>

		<InputGroup
			title="Upload IFU"
			desc="Please upload the Instructions For Use (IFU) for the treatment plan."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			
			<UploadBox 
				theme="dark"
				designation="instructions-for-use"
				:maxFiles="1"
				:case="thisCase"
				@done="ifuUploadDone"
				@filesAdded="ifuFilesAdded"
				/>

		</InputGroup>

		<InputGroup
			title="Set Treatment Plan Deadline"
			desc="Please set the deadline date for when the user must approve the treatment plan."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<InputDateTime 
				v-model="caseForm.treatment_plan_deadline" 
				:darkMode="true"
				mode="date"
				/>

		</InputGroup>


		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save" 
				@click="submitTreatmentPlanSettings"
				:disabled="!canSave"
				/>
		</InputGroup>


	</div>
</template>

<script>


import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import InputTextarea from "@/Components/InputTextarea"
import InputDateTime from "@/Components/InputDateTime"
import InputFancyRadio from "@/Components/InputFancyRadio"
import Button from "@/Components/Button"
import UploadBox from '@/Components/Upload/UploadBox'

export default {
	props: [
		'thisCase'
	],
	components: {
		InputGroup,
		InputText,
		InputTextarea,
		InputDateTime,
		InputFancyRadio,
		Button,
		UploadBox,
	},
	data: () => {
		return {
			caseForm: {
				treatment_plan_deadline: '', // YYYY-MM-DD
				treatment_plan_notes: ''
			},
			filesNeedUploading: false,
			ifuFileNeedsUploading: false
		}
	},
	mounted(){
		this.caseForm.treatment_plan_deadline = this.thisCase.treatment_plan_deadline
		this.caseForm.treatment_plan_notes = this.thisCase.treatment_plan_notes
	},
	methods: {
		submitTreatmentPlanSettings(){
			if(this.canSave){
				this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/treatment-plan`, this.caseForm)
			}
		},
		uploadDone(){
			this.filesNeedUploading = false
		},
		filesAdded(){
			this.filesNeedUploading = true
		},
		ifuUploadDone(){
			this.ifuFileNeedsUploading = false
		},
		ifuFilesAdded(){
			this.ifuFileNeedsUploading = true
		}
	},
	computed: {
		canSave(){

			if(this.filesNeedUploading){
				return false
			}

			if(this.caseForm.treatment_plan_deadline == '' || this.caseForm.treatment_plan_deadline == null){
				return false
			}

			return true
		}
	}
}

</script>

<style scoped lang="sass">

// .treatment-plan



</style>